<template>
    <v-row align="center" style="justify-content:right">
        <v-col cols="6" md="3" sm="3" xs="3">
            <v-subheader>Rows per Page :</v-subheader>
        </v-col>
        <v-col cols="6" md="3" sm="3" xs="3">
            <v-select
              :items="rows"
              v-model="pageLimit"
              colsor="#F36F2E"
              style="border-radius:5px !important;width:100px"
            ></v-select>
        </v-col>
        <v-col cols="6" md="3" sm="3">
            <span> {{ this.page}} of {{this.totalPage}}</span>
        </v-col>
        <v-col cols="6" md="3" sm="3">
            <v-btn :disabled="isPreviousButtonDisabled" @click.native="previousPage" class="ma-2" icon>
                <v-icon>
                  mdi-chevron-left
                </v-icon>
            </v-btn>
            <v-btn :disabled="isNextButtonDisabled" @click="nextPage" class="ma-2" icon>
                <v-icon>
                  mdi-chevron-right
                </v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props:{
        rows:{
            type: Array,
            required:true
        },
        limit:{
            type:Number,
            required:true
        },
        page:{
            type:Number,
            required:true
        },
        totalPage:{
            type:Number,
            required: true
        }
    },
    data: () => ({
        
    }),
    computed: {
        pageLimit:{
            get: function(){
                return this.limit
            },
            set: function(newValue){
                this.$emit('reload',newValue)   
            }
        },
        isPreviousButtonDisabled() {
            return this.page === 1
        },
        isNextButtonDisabled() {
            return this.page === this.totalPage || this.totalPage === 0
        }
    },
    methods:{
        nextPage(){
            this.$emit('nextPage')
        },
        previousPage(){
            this.$emit('previousPage')
        },
    }
}
</script>